import React from 'react';
import { NavLink } from 'react-router-dom';
import { RoutePaths } from '../../routes';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import styles from './about_nav.less';

const AboutNav: React.SFC<{}> = (props) => {
  return (
    <section className={styles.AboutNav}>
      <ContentWrapper>
        <nav>
          <ul className={styles.list}>
            <li>
              <NavLink
                to={`${RoutePaths.ABOUT}`}
                className={styles.link}
                activeClassName={styles.linkActive}
                exact={true}
              >
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${RoutePaths.WHO}`}
                className={styles.link}
                activeClassName={styles.linkActive}
              >
                Who We Are
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${RoutePaths.NEWS}`}
                className={styles.link}
                activeClassName={styles.linkActive}
              >
                Omnia News
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${RoutePaths.FAQS}`}
                className={styles.link}
                activeClassName={styles.linkActive}
              >
                FAQs
              </NavLink>
            </li>
          </ul>
        </nav>
      </ContentWrapper>
    </section>
  );
};

export default AboutNav;
